import { css, type Theme } from "@emotion/react";

export const tag = css`
  margin-left: 0.25rem;
  margin-bottom: 0.25rem;
`;

export const excludedStyles = (theme: Theme) => css`
  border-color: ${theme.warning.borderBase};
  background-color: ${theme.warning.backgroundMuted};

  &:hover {
    border-color: ${theme.warning.borderHover};
    background-color: ${theme.warning.backgroundMuted};
  }
`;
